module.exports = __webpack_public_path__ + "img/line-comparison_10g.0475c45b.png";